export const validNum = {
  MAX_40: 40,
  MAX_50: 50,
  MAX_70: 70,
  MAX_80: 80,
  MAX_100: 100,
  MAX_150: 150,
  MAX_200: 200,
  MAX_255: 255,
  MAX_500: 500,
  MAX_600: 600,
  MAX_1000: 1000,
} as const;

type ReturnConvertStringToNumber = {
  newValue: number | '';
  isNaN: boolean;
};

export const convertStringToNumber = (
  str: string
): ReturnConvertStringToNumber => {
  if (str === '') return { newValue: '', isNaN: false };

  const newStr = str.replace(/[０-９．]/g, (s) =>
    String.fromCharCode(s.charCodeAt(0) - 0xfee0)
  );
  const value = Number(newStr);
  return { newValue: value, isNaN: isNaN(value) };
};
